// extracted by mini-css-extract-plugin
export var card = "SummaryCard-module--card--91395";
export var cardPrimary = "SummaryCard-module--cardPrimary--3b8d7";
export var editButton = "SummaryCard-module--editButton--5ac9d";
export var headerWrapper = "SummaryCard-module--headerWrapper--0a7dc";
export var isCol = "SummaryCard-module--isCol--cf744";
export var isRow = "SummaryCard-module--isRow--5a088";
export var liWrapper = "SummaryCard-module--liWrapper--203ce";
export var primaryTitle = "SummaryCard-module--primaryTitle--62d2d";
export var title = "SummaryCard-module--title--1f00b";
export var titleLarge = "SummaryCard-module--titleLarge--2e670";